export default __webpack_public_path__ + "static/media/contratar_02.b0679e64.jpg";